/**
 * geo-fence.js
 * wholesalemoulding.ca
 *
 * All config values are read from the #geo-fence-overlay data attributes,
 * which are set dynamically by geo-fence.liquid from Theme Settings.
 * To change country, region, phone, hours, or toggle — use:
 *   Online Store → Customize → Theme Settings → Geo-Fencing
 *
 * Uses ipapi.co (free, no API key, 1000 req/day)
 * Result cached in cookie for 24 hours.
 */

(function () {
  'use strict';

  var COOKIE_NAME    = 'mm_geo_ok';
  var CACHE_HOURS    = 24;
  var OVERLAY_ID     = 'geo-fence-overlay';

  /* ─── Read config from overlay data attributes ─── */
  function getConfig() {
    var el = document.getElementById(OVERLAY_ID);
    if (!el) return null;
    return {
      enabled:    el.dataset.geoEnabled   !== 'false',
      country:   (el.dataset.geoCountry   || 'CA').toUpperCase().trim(),
      region:    (el.dataset.geoRegion    || 'NS').toUpperCase().trim(),
      blockCart:  el.dataset.geoBlockCart !== 'false'
    };
  }

  /* ─── Cookie helpers ─── */
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, hours) {
    var expires = new Date();
    expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value)
      + '; expires=' + expires.toUTCString()
      + '; path=/; SameSite=Lax';
  }

  /* ─── Show / hide overlay ─── */
  function showOverlay() {
    var el = document.getElementById(OVERLAY_ID);
    if (el) {
      el.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  }

  function hideOverlay() {
    var el = document.getElementById(OVERLAY_ID);
    if (el) el.style.display = 'none';
    document.body.style.overflow = '';
  }

  /* ─── Block forms ─── */
  function blockForms() {
    var skipPatterns = ['/search', '/account/login', '/account/register', '/account/reset', '/account/addresses'];
    document.querySelectorAll('form').forEach(function (form) {
      var action = form.getAttribute('action') || '';
      var skip = skipPatterns.some(function (p) { return action.indexOf(p) !== -1; });
      if (skip) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        showOverlay();
        return false;
      }, true);
    });
  }

  /* ─── Block cart & checkout buttons (optional via setting) ─── */
  function blockCart() {
    var selectors = [
      '[name="add"]',
      '.product-form__submit',
      '.cart__checkout-button',
      'a[href="/checkout"]',
      'button[name="checkout"]'
    ];
    document.querySelectorAll(selectors.join(', ')).forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        showOverlay();
      }, true);
    });
  }

  /* ─── Close button ─── */
  function bindClose() {
    document.addEventListener('click', function (e) {
      if (!e.target) return;
      if (e.target.id === 'geo-fence-close' || e.target.id === OVERLAY_ID) {
        hideOverlay();
      }
    });
  }

  /* ─── IP location check ─── */
  function checkLocation(config) {
    // Developer bypass / theme editor / localhost bypass so preview and editing are never blocked
    var isPreviewOrDev = (
      window.location.search.indexOf('preview_theme_id') !== -1 ||
      window.location.search.indexOf('geo=bypass') !== -1 ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === 'localhost' ||
      (window.Shopify && window.Shopify.designMode)
    );

    // Allow explicit testing via URL params: ?geo_test=block or ?geo_test=allow
    if (window.location.search.indexOf('geo_test=block') !== -1) {
      showOverlay();
      blockForms();
      if (config.blockCart) blockCart();
      return;
    }

    if (isPreviewOrDev || window.location.search.indexOf('geo_test=allow') !== -1) {
      return; // Known preview/development environment — allow full shopping access
    }

    var cached = getCookie(COOKIE_NAME);

    if (cached === 'allow') return;        // known good — do nothing
    if (cached === 'block') {              // known bad — show block immediately
      showOverlay();
      blockForms();
      if (config.blockCart) blockCart();
      return;
    }

    // No cache yet — call IP API
    fetch('https://ipapi.co/json/', { method: 'GET', headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('ipapi error ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var country = (data.country_code || '').toUpperCase();
        var region  = (data.region_code  || '').toUpperCase();
        var allowed = (country === config.country && region === config.region);

        if (allowed) {
          setCookie(COOKIE_NAME, 'allow', CACHE_HOURS);
        } else {
          setCookie(COOKIE_NAME, 'block', CACHE_HOURS);
          showOverlay();
          blockForms();
          if (config.blockCart) blockCart();
        }
      })
      .catch(function (err) {
        // Fail open on API error — don't punish visitor for a bad lookup
        console.warn('[GeoFence] Location check failed — allowing access.', err);
        setCookie(COOKIE_NAME, 'allow', 1);
      });
  }

  /* ─── Init ─── */
  function init() {
    var config = getConfig();

    // Overlay not in DOM means geo_fence_enabled = false in theme settings
    if (!config || !config.enabled) return;

    bindClose();
    checkLocation(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
